import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-search-button-group',
  templateUrl: './search-button-group.component.html',
})
export class SearchButtonGroupComponent implements OnInit {
  @Output() searchEvent = new EventEmitter<any>();
  @Output() clearEvent = new EventEmitter<any>();
  @Input() disabled: boolean = false;
  constructor() {}

  ngOnInit(): void {}
}
